import { gql } from "@apollo/client";

export const OPERATION_STATUS_FRAGMENT = gql`
  fragment OperationStatusFragment on OperationStatus {
    ok
    errorTitle
    errorMessage
  }
`;
